enum EntityType {
	Undefined           = 0,
	Agency				= 1,
	AgencyUser		    = 2,
	Worker              = 3,
	Company		        = 4,
	Location			= 5,
	Contact             = 6,
	Department          = 7,
	Branch              = 8,
	Desk                = 9,
	Group               = 10,
	BusinessHours       = 11,
	ConversationTopic   = 12,
	ChatBot             = 13,
	Activity            = 14,
	Opportunity         = 15,
	Booking             = 100,
	Invoice             = 150,
	Job                 = 200,
	Campaign            = 300,
	SpecOut             = 350,
}

export default EntityType;